import React from 'react';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useForm, SubmitHandler } from 'react-hook-form';
import Input from '../../../../components/Input';
import { useToast } from "@chakra-ui/core";
import Button from 'src/components/Button';
import { AiOutlineClose } from 'react-icons/ai';
import jobApi from 'src/service/job';

import useStyles from './styles';

interface IModalProps {
  open: boolean;
  handlecancel: () => void;
  handleBack: () => void;
}

type BatchProps = {
  name: string,
  startDate: string,  
  endDate: string,  
}

const FormVehicle = (props: IModalProps) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const toast = useToast();

  const handleSubmitForm: SubmitHandler<BatchProps> = async (values) => {

    const formatValues = {
      ...values,
      startDate: new Date(values.startDate).toISOString(),
      endDate: new Date(values.endDate).toISOString()
    }

    try {
      await jobApi.post('batch', formatValues);

      props.handlecancel()
      toast({
      position: "top-right",
      title: "Cadatro realizado.",
      description: "Você cadastrou um novo lote de veículos",
      status: "success",
      duration: 4000,
      isClosable: true,
      });
    } catch (err) {
      props.handlecancel();
      toast({
        position: "top-right",
        title: "Algo deu errado.",
        description: "Por favor verifique os dados novamente",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    
  };

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby=""
        classes={{ paper: classes.dialogPaper }}
      >
        <Box component="header" className={classes.header}>
          <Typography className={classes.title}>
            Cadastrar um novo Lote de Veículos
          </Typography>
          <button type="button" onClick={props.handlecancel}>
            <AiOutlineClose size={16} />
          </button>
        </Box>
         <form onSubmit={handleSubmit(handleSubmitForm)} style={{ marginTop: '16px'}}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input 
                  isFullWidth
                  name='name'
                  label='Nome'
                  ref={register({ required: 'O modelo do veículo é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  isFullWidth
                  name='startDate'
                  label='Data de início'
                  type='datetime-local'
                  ref={register({ required: 'O modelo do veículo é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  name='endDate'
                  label='Data de encerramento'
                  type='datetime-local'
                  ref={register({ required: 'Ano/Modelo é obrigatório'})}
                  error={errors}
                />
              </Grid>
            </Grid>       
            <Divider style={{ width: '100%'}}/>
          <Box className={classes.wrapperButtons}>
            <Button
              fill={false}
              onClick={props.handlecancel}
            >
              Cancelar
            </Button>
            <Button type="submit" className={classes.button}>
              Adicionar Lote
            </Button>
          </Box>
        </form>
      </Dialog>
    </>
  );
};
export default FormVehicle;